module.exports = __webpack_public_path__ + "static/img/15.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/15.png
// module id = Vqmh
// module chunks = 0